import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { FlexLayoutModule} from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from "@angular/material/radio";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FormsModule } from '@angular/forms';
import { HomeLayoutComponent } from "./homelayout.component"; 
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
@NgModule({
  declarations: [
    HomeLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
   
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MatDividerModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FlexLayoutModule,
    MatMenuModule,
    MatListModule,
    MatCheckboxModule,
    MatSidenavModule,

  ],
  providers:[
    MatDatepickerModule,  MatNativeDateModule,
  ],
  exports: [RouterModule,  
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    HomeLayoutComponent]
})
export class HomeLayoutModule { }
